var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubscriptionsOutlined = function SvgSubscriptionsOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 42,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 21,
    r: 20,
    stroke: "#666",
    strokeDasharray: "1 6",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M28.96 21.394a8.5 8.5 0 0 1-15.815 3.357l-.25-.432m-.842-4.71a8.5 8.5 0 0 1 15.815-3.357l.25.432M12 26.567l.732-2.732 2.732.732m10.085-8.132 2.732.733.732-2.733m-8.506 1.566v4.5l2.5 1.5"
  })));
};
export default SvgSubscriptionsOutlined;